<template>
    <b-table striped hover :fields="structure_list_fields" :items="structures" :filter="filter">
        <template v-slot:cell(date_requested)="data">
          {{ data.item.structure_case.withdrawal_date }}
        </template>
        <template v-slot:cell(reason)="data">
          {{ data.item.structure_case.final_status }}
        </template>

        <template v-slot:cell(approve)="data">

            <!-- Only show approve/decline buttons for new requests -->
            <b-button v-if="data.item.status == 'New Request'" @click="approve(data.index)" size="sm" variant="success" class="w-20">Approve</b-button>
            <b-button v-if="data.item.status == 'New Request'" @click="decline(data.index)" size="sm" variant="danger" class="w-20 ml-2">Decline</b-button>

            <!-- Otherwise, if it has been approved (and waiting for Final Status) -->
            <div v-if="data.item.status == 'Approved'">
                Approved on {{ data.item.last_status_changed }}
            </div>

            <!-- Otherwise, if it has been declined -->
            <div v-if="data.item.status == 'Declined'">
                Declined on {{ data.item.last_status_changed }}
            </div>

            <!-- And for those that are already completed... -->
            <div v-if="data.item.status == 'Final Status Form Completed'">
                Final Status Form completed on {{ data.item.last_status_changed }}
            </div>
            
        </template>

        <template v-slot:cell(final_status)="data">
            <span v-if="data.item.final_status == 'New Request' && data.item.unresolved_aesae.length == 0 && data.item.withdrawn != 'true'">Waiting for Subject Withdrawal Form</span>
            <span v-else>{{ data.value }}</span>
        </template>
    </b-table>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions, mapState } from "vuex";

import * as moment from 'moment';

import * as _ from 'lodash';

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      structure_list_fields: [
        { key: "structure_id", label: "Structure ID" },
        { key: "date_requested" },
        { key: "status" },
        { key: "reason" },
        { key: "approve" }
      ],
      structures: [],
      componentKey: 0,
      filter: null,
      active_aesae_list: [],
      active_aesae_modal_title: 'AE/SAE Cases',
    };
  },
  computed: {

    ...mapState("user", ["user", "myGroups"]),
  },
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/structures/get_withdrawal_requests").then(response => {
      _.each(response.data, function(item){
         item.last_status_changed = moment(item.last_status_changed).format('MMM Do, YYYY');
       });
      that.structures = response.data;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('subjectfinalstatus', 
            ['getSubjectFinalCount', 'setSubjectFinalCount']),
     ...mapActions('subjectfinalstatuscompleted', 
            ['getSubjectFinalCompletedCount', 'setSubjectFinalCompletedCount']),
    refreshSideNavCount(){
      this.getSubjectFinalCount().then((response) => {
                this.setSubjectFinalCount(response.data);
            });
    },
     view_aesae_list: function(index){
      let that = this;
      that.active_aesae_list = that.subjects[index].unresolved_aesae;
      that.active_aesae_modal_title = 'AE/SAE Cases for ' + that.subjects[index].name;
    },
    approve: function(index){
      let that = this;
      HTTP.post("/kenya/structure/status/"+that.structures[index].id+"/", {
        status: 'approve'
      }).then(response => {
          that.structures.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });


    },
    decline: function(index){
      let that = this;
      HTTP.post("/kenya/structure/status/"+that.structures[index].id+"/", {
        status: 'decline'
      }).then(response => {
          that.structures.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });
    }
  }
};
</script>